








































































































import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  onBeforeMount,
  inject,
} from '@vue/composition-api'
import EditLicense from './components/license/EditLicense.vue'
import { getLicenses, deleteLicenses } from '@/shared/api'
import { alertSymbol } from '@/shared/state-management/symbols'
import { License } from '@/shared/types'
import { pagination } from '@/shared/utils'

export default defineComponent({
  name: 'Licenses',
  components: {
    EditLicense,
  },
  setup(props, context) {
    const licenses = ref([] as License[])
    const editLicenseDialogOpen = ref(false)
    const editLicense = ref(null as License)
    const search = ref('')
    const selectedLicenses = ref([])
    const $alert = inject(alertSymbol) as Function
    const loading = ref(false)
    const data = reactive({
      headers: [
        {
          text: context.root.$t('licenses.name'),
          value: 'name',
        },
        {
          text: context.root.$t('licenses.type'),
          value: 'isTeacherType',
        },
        {
          text: 'Aktionen',
          value: 'actions',
        },
      ],
      search: undefined,
    })

    const refreshLicenses = async () => {
      loading.value = true
      licenses.value = await getLicenses()
      loading.value = false
    }

    onBeforeMount(refreshLicenses)
    const createLicense = () => {
      editLicense.value = null
      editLicenseDialogOpen.value = true
    }
    const editItem = (license: License) => {
      editLicense.value = { ...license }
      editLicenseDialogOpen.value = true
    }

    const deleteItem = async (license: License) => {
      await $alert({
        type: 'confirm',
        text: context.root.$t('licenses.deleteConfirm', {
          licenseName: license.name,
        }),
      })
      await deleteLicenses([license.name])
      $alert({
        type: 'success',
        text: context.root.$t('licenses.deleteSuccess'),
      })
      refreshLicenses()
    }

    const deleteSelected = async () => {
      const selectedNames = selectedLicenses.value.map(
        (license) => license.name
      )
      await $alert({
        type: 'confirm',
        text: context.root.$t('licenses.deleteSelectedConfirm', {
          name: selectedNames.join(', '),
        }),
      })
      await deleteLicenses(selectedNames)
      $alert({
        type: 'success',
        text: context.root.$t('licenses.deleteSelectedSuccess', {
          name: selectedNames.join(', '),
        }),
      })
      refreshLicenses()
    }

    const onLicenseCreated = () => {
      refreshLicenses()
      editLicenseDialogOpen.value = false
      editLicense.value = null
    }

    const onLicenseEdited = () => {
      refreshLicenses()
      editLicenseDialogOpen.value = false
      editLicense.value = null
    }

    return {
      ...toRefs(data),
      licenses,
      search,
      onLicenseCreated,
      editLicenseDialogOpen,
      selectedLicenses,
      createLicense,
      editItem,
      deleteItem,
      deleteSelected,
      loading,
      editLicense,
      onLicenseEdited,
      pagination,
    }
  },
})
